const PushOnMount = {
  mounted() {
    const { event, payload = '{}' } = this.el.dataset

    this.pushEvent(event, JSON.parse(payload))
  },
}

export default PushOnMount
